import React, {lazy, Suspense} from 'react'
import {Switch, Route} from 'react-router-dom'
import {Typography} from 'antd'

//style
import './index.css'
import typo from "../../constants/dictionaries";

const {Title} = Typography;

// Components
const BCPDList = lazy(() => import('./BaoCaoPheDuyet/list'));
const BCPDDetail = lazy(() => import('./BaoCaoPheDuyet/detail/thongTinChiTiet'));
const BCPDForm = lazy(() => import('./BaoCaoPheDuyet/form'));

const TramQuanTrac = lazy(() => import('./TramQuanTrac'));

const BaoCaoDinhKy = lazy(() => import('./BaoCaoDinhKy'))


export default ({match}) => {
  const BCDK = 'bao-cao-dinh-ky'
  return (
    <Suspense fallback={() => <Title level={4}>Loading</Title>}>
      <Switch>
        <Route exact path={`${match.path}/${BCDK}`} component={BaoCaoDinhKy}/>
        <Route exact path={`${match.path}/tram-quan-trac`} component={TramQuanTrac}/>
      </Switch>
      <Switch>
       <Route exact path={`${match.path}/bao-cao-phe-duyet`} component={BCPDList}/>
       <Route path={`${match.path}/bao-cao-phe-duyet/add`} render={(props) => <BCPDForm {...props}/>}/>
        <Route path={`${match.path}/bao-cao-phe-duyet/edit/:id`} render={(props) => <BCPDForm {...props}/>}/> 
       <Route path={`${match.path}/bao-cao-phe-duyet/:id`} component={BCPDDetail}/> 
       </Switch>
    </Suspense>
  )
}